"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _PaginationItem.default;
  }
});

var _PaginationItem = _interopRequireDefault(require("./PaginationItem"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/PaginationItem/index.js
// module id = 967
// module chunks = 0